import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Home2 from '../views/super/Home.vue';

Vue.use(VueRouter);
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/project',
    name: 'project',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/project.vue'),
  },
  {
    path: '/warn',
    name: 'warn',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/warn.vue'),
  },
  // 404页面
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue'),
  },
  {
    path: '/all',
    name: 'all',
    component: () => import(/* webpackChunkName: "about" */ '../views/all.vue'),
    children: [
      {
        path: 'general',
        name: 'general',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/general.vue'),
      },
      {
        path: 'index',
        name: 'index',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/index.vue'
          ),
      },
      // 子菜单开始
      {
        path: 'jinxian',
        name: 'jinxian',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/jinxian.vue'
          ),
      },
      {
        path: 'bianyaqi',
        name: 'bianyaqi',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/bianyaqi.vue'
          ),
      },
      {
        path: 'gaoyahuilu',
        name: 'gaoyahuilu',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/gaoyahuilu.vue'
          ),
      },
      {
        path: 'wenshidu',
        name: 'wenshidu',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/wenshidu.vue'
          ),
      },
      {
        path: 'shipin',
        name: 'shipin',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../components/monitor/shipin.vue'
          ),
      },
      // 子菜单结束
      {
        path: 'report',
        name: 'report',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/report.vue'),
      },
      {
        path: 'monthReport',
        name: 'monthReport',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/monthReport.vue'),
      },
      {
        path: 'peak',
        name: 'peak',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/peak.vue'),
      },
      {
        path: 'analysis',
        name: 'analysis',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/analysis.vue'),
      },
      {
        path: 'equipment',
        name: 'equipment',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/equipment.vue'),
      },
      {
        path: 'user',
        name: 'user',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/user.vue'),
      },
      {
        path: 'event',
        name: 'event',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/event.vue'),
      },
    ],
  },

  // super admin的路由
  {
    path: '/super',
    name: 'super',
    component: Home2,
    children: [
      {
        path: '',
        name: 'project2',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/project.vue'),
      },
      {
        path: 'info/:id',
        name: 'info',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/info.vue'),
      },
      {
        path: 'role',
        name: 'role',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/role.vue'),
      },
      {
        path: 'role',
        name: 'role',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/role.vue'),
      },
      {
        path: 'user',
        name: 'user',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/user.vue'),
      },
      {
        path: 'alarm',
        name: 'alarm',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/super/alarm.vue'),
      },
      // 告警配置
      {
        path: 'warnConfig',
        name: 'warnConfig',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/super/warnConfig.vue'
          ),
      },
      // -------------------------其他项目开始---------------
      {
        path: 'otherResource',
        name: 'otherResource',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/super/otherResource.vue'
          ),
      },
      {
        path: 'otherRole',
        name: 'otherRole',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/super/otherRole.vue'
          ),
      },
      {
        path: 'addresource',
        name: 'addresource',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/super/addresource.vue'
          ),
      },
      //  // -------------------------其他项目结束-----------------
    ],
  },
];
const router = new VueRouter({
  routes,
});

export default router;
